import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
//   {
//     path: '',
//     redirect: '/index'
//   },
//   {
//     path: '/home',
//     redirect: '/index'
//   },
  {
    path: '/index',
    name: 'Test',
    meta: {
      title: '首页',
      showHeader: false
    },
    //component: () => import('../views/Test')
  },
  {
    path: '/main',
    name: 'Main',
    component: () => import('../views/Main')
    // children: [
    //   {
    //     path: 'schoolsummary',
    //     meta: {
    //       title: '学校概况',
    //       subTitle: '学校简介',
    //       englishtitle: 'School Profile',
    //       showHeader: true
    //     },
    //     component: () => import('../views/Summary/SchoolSummary')
    //   }
    // ]
  }
]

const router = new VueRouter({
  mode: 'history',
  // base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  // if (to.meta.title) {
  // document.title = to.meta.title
  // }
  // 加入百度统计

})

export default router
